export default __webpack_public_path__ + "static/media/handbrake.e387323d.svg";